<script>
import {getWelcomeData} from '@/services/services'
import DibbleAPI from '../../api'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import {PATH} from '@/constant/Path.js'
import DibbleJS from "@/dibble";
import {EventBus} from "@/utils/event-bus";

export default {
    name: "Welcome",
    data() {
        return {
            dataWelcome: {},
            bottomActiveTab: 'campaign'
        }
    },
    created() {
        const uid = this.$route.params?.uid;
        if (!uid) {
            this.$router.push(PATH.SORRY)
        } else {
            DibbleJS.setUID(uid);
            this.getDashboardData();
        }
    },
    watch: {
        dataWelcome: function (val) {
            if (val?.fund_logo) {
                EventBus.$emit('update-logo', val.fund_logo);
                localStorage.setItem('fund_logo', val.fund_logo);
            }
        }
    },
    methods: {
        getWelcomeData,
        getDashboardData() {
            DibbleJS.showLoader();
            this.getWelcomeData()
                .then(res => {
                    DibbleJS.hideLoader();
                    if (DibbleAPI.isResponseSuccess(res.data)) {
                        this.dataWelcome = res.data
                    } else {
                        this.$router.push(PATH.SORRY)
                    }
                })
                .catch(e => {
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(e.toString());
                })
        },
        goToPageDonate () {
            this.$router.push(PATH.DONATE)
        },
        formatCurrency (value) {
            if (value) {
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
    },
    components: {
        VueSlickCarousel
    }
}
</script>
<template src="./template/index.html">
</template>
<style scoped>
    .img-carousel {
        border-radius: 50px;
    }
    .goal-amount {
        font-size: 50px;
        background: #1084B6;
        background: linear-gradient(to right, #1084B6 0%, #5dbfe7 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: 700;
    }
    .goal-amount-sub {
        font-size: 20px !important;
        font-weight: 400 !important;
    }

    .progress.donated-amount {
        height: 60px;
        background-color: #FFF;
        border-radius: 50px;
    }

    .progress.donated-amount .progress-bar {
        height: 60px !important;
        border-radius: 20px !important;
    }
    
    .welcome-top-bg-image {
        height: 600px;
        background-position: bottom center;
    }
    
    .welcome-top-bg-image:after {
        height: 100%;
    }
</style>
